import { Avatar, Box, Button, Grid2, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as BoostIcon } from "Assets/Icons/Home/BoostIcon.svg";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import Creator from "Assets/Images/Creator.svg";

const styles = (theme) => ({
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  "& .interviewExp": {
    background: theme.palette.yellow.main,
    borderRadius: "8px",
    padding: "10px 15px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&>p": {
      display: "flex",
      alignItems: "center",
      gap: "10px",
    },
  },
  "& .discussionCard": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "8px",
  },
});

const DiscussionHub = () => {
  return (
    <Grid2 sx={styles}>
      <Box
        display={"flex"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography
          display={"flex"}
          alignItems={"center"}
          fontWeight={500}
          gap="10px"
          variant="title"
        >
          Discussion Hub
          <Box
            sx={(theme) => ({
              borderRadius: "4px",
              padding: "4px 8px",
              background: theme.palette.yellow.main,
            })}
          >
            <Typography variant="body2">New</Typography>
          </Box>
        </Typography>
        <Button variant="outlined">All Posts</Button>
      </Box>
      <Grid2 className="interviewExp">
        <Typography fontWeight={500}>
          <PrimaryIcon
            icon={BoostIcon}
            fill={false}
            height="50px"
            width="50px"
          />
          Boost your preparation with real interview questions and insider
          insights from real interviews
        </Typography>
        <Button variant="outlined" color="secondary">
          View Interview Experiences
        </Button>
      </Grid2>
      <Grid2 container spacing={"15px"}>
        {["#FEE0CC", "#D4F7ED", "#E2DBFA", "#E0F3FF"].map((item, i) => {
          return (
            <Grid2 key={i} size={3} className="discussionCard">
              <Box
                sx={{ background: item, padding: "8px", borderRadius: "8px" }}
              >
                <Box
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography fontWeight={500}>Created By</Typography>
                  <Avatar
                    sx={{ width: 32, height: 32 }}
                    src={Creator}
                    alt="fsf"
                  />
                </Box>
                <Box
                  mt={"15px"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  gap="10px"
                  sx={{
                    "& button": {
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    },
                  }}
                >
                  <Button variant="outlined" color="secondary">
                    Views <span>32089</span>
                  </Button>
                  <Button variant="outlined" color="secondary">
                    Replies <span>32</span>
                  </Button>
                </Box>
              </Box>
              <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"space-between"}
                mt="20px"
                mb="10px"
              >
                <Typography fontWeight={500}>
                  Delhivery | SDE1 | Offer
                </Typography>
                <Button variant="outlined" color="secondary">
                  Details
                </Button>
              </Box>
            </Grid2>
          );
        })}
      </Grid2>
    </Grid2>
  );
};

export default DiscussionHub;
